import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
export function OfferSection() {
  const features = ['Diseño moderno y profesional', 'Optimización para móviles', 'Botón de WhatsApp integrado', 'Diseño preparado para reservas', 'Integración con Google Maps'];
  return <section id="precio-web" className="py-24 bg-dark relative overflow-hidden scroll-mt-20" data-id="element-119">
      <div className="absolute top-0 right-0 w-1/2 h-full bg-primary/5 blur-[150px] rounded-full pointer-events-none" data-id="element-120"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-121">
        <motion.div className="bg-gradient-to-br from-gray-900 to-dark border border-gray-800 rounded-3xl p-8 md:p-12 shadow-2xl" initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-122">
          <div className="text-center mb-10" data-id="element-123">
            <div className="inline-block bg-primary/20 text-primary px-4 py-1.5 rounded-full text-sm font-semibold mb-6 border border-primary/30" data-id="element-124">
              OFERTA DE LANZAMIENTO
            </div>
            <h2 className="md:text-4xl font-bold text-white mb-4 text-[28px]" data-id="element-125">
              Web profesional diseñada para conseguir clientes
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-126">
            <div data-id="element-127">
              <ul className="space-y-4" data-id="element-128">
                {features.map((feature, index) => <li key={index} className="flex items-center gap-3" data-id="element-129">
                    <div className="w-6 h-6 rounded-full bg-primary/20 flex items-center justify-center flex-shrink-0" data-id="element-130">
                      <CheckIcon className="w-4 h-4 text-primary" data-id="element-131" />
                    </div>
                    <span className="text-gray-300 text-lg" data-id="element-132">{feature}</span>
                  </li>)}
              </ul>
            </div>

            <div className="bg-white/5 rounded-2xl p-8 border border-white/10 text-center" data-id="element-133">
              <div className="text-gray-400 line-through text-2xl mb-2" data-id="element-134">
                497€
              </div>
              <div className="text-6xl font-bold text-white mb-4" data-id="element-135">297€</div>
              <p className="text-accent font-medium mb-4" data-id="element-136">
                Pago único. Sin mensualidades.
              </p>
              <div className="flex flex-col gap-1.5 mb-6 text-sm text-gray-300" data-id="element-137">
                <span data-id="element-138">✔ Pago único</span>
                <span data-id="element-139">✔ Sin mensualidades</span>
                <span data-id="element-140">✔ Web lista en 72h</span>
              </div>

              <a id="boton-compra-297" href="https://wa.me/34691204745?text=Hola,%20mi%20nombre%20es%20____.%20Soy%20de%20____.%20Quiero%20m%C3%A1s%20informaci%C3%B3n%20sobre%20la%20web%20profesional%20por%20297%E2%82%AC%20para%20mi%20negocio.%20Gracias." target="_blank" rel="noopener noreferrer" className="block w-full bg-accent hover:bg-green-600 text-white py-4 rounded-xl font-bold text-lg transition-colors shadow-lg shadow-accent/20 scroll-mt-[40vh]" data-id="element-141">
                Quiero mi web por 297€
              </a>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}